import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Segment,
} from 'semantic-ui-react';

const buttonStyle = {
  margin: '20px 0',
};

const messageStyle = {
  paddingTop: '30px',
  display: 'block',
};

const TryAgainView = props => (
  <Segment height="100" textAlign="center">
    <h4 style={messageStyle}>{props.errorMessage}</h4>
    <Button style={buttonStyle} onClick={props.onClick}>{ props.buttonLabel }</Button>
  </Segment>
);

TryAgainView.propTypes = {
  buttonLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

TryAgainView.defaultProps = {
  errorMessage: 'Something went wrong. Please try again.',
  buttonLabel: 'Try again',
};

export default TryAgainView;



/** WEBPACK FOOTER **
 ** ./src/components/try-again-view/index.js
 **/